import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticStyle:{"position":"relative"},attrs:{"outlined":""}},[_c(VCardTitle,[_vm._v(_vm._s(_vm.title))]),_c(VChip,{staticStyle:{"position":"absolute","top":"-1px","right":"-1px"},attrs:{"label":""}},[_vm._v(_vm._s(_vm.quantity))]),_c(VCardText,{staticClass:"text-h4 text-center pa-1"},[_vm._v(" "+_vm._s(_vm.currencyFormat(_vm.amount))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }